module.exports = __webpack_public_path__ + "static/media/apple-iphone12pro-gold-portrait.af64504a.png";